import { RoleViewModel } from '@ng-gems/api/midback';

import { AccessControlRole } from '@models/account/access-control-role.model';
import { RoleType } from '@models/types/role-type';

import { AccessControlCapacityAdapter } from './access-control-capacity.adapter';
import { ApiAdapter } from './adapter';

export class AccessControlRoleAdapter extends ApiAdapter<AccessControlRole> {
  private accessControlCapacityAdapter = new AccessControlCapacityAdapter();

  get(json: RoleViewModel): AccessControlRole {
    return new AccessControlRole({
      id: json.id,
      name: json.name,
      type: json.type as RoleType,
      description: json.description,
      capacities: this.accessControlCapacityAdapter.list(json.capacities),
    });
  }
}
